module.exports = __webpack_public_path__ + "img/quest_icon_0061_target3.8e2613b1.png";